// extracted by mini-css-extract-plugin
export var childrenContainer = "_a6-0";
export var virtualScrollArea = "_a6-1";